<template>
  <div class="productcenterhtml">
    <div class="productcenterhead">
      <div class="productcenterheadtext">
        <p
          style="
            font-size: 18px;
            color: #275479;
            font-weight: bold;
            line-height: 24px;
            margin-left: 3px;
            letter-spacing: 2px;
          "
        >
          套利交易工具
        </p>
        <p
          style="
            font-size: 15px;
            color: #000000;
            line-height: 20px;
            letter-spacing: 1px;
          "
        >
          支持内外盘套利交易以及自由配比的套利合约交易，多种算法交易防止瘸腿，一键完成套利下单，像单个合约下单一样方便。
        </p>
      </div>
    </div>
    <div class="productcenterbody">
      <div class="productcenterbodytag">
        <ul style="padding-top: 70px">
            <li class="pli" v-for="(item,index) in leftnav" :key="index">
                <div v-bind:class="[item.active ? class4 : class3]"></div>
                <div v-bind:class="[item.active ? class1 : class5]" @click="show(index)">
                    <div style="width: 45px; height: 40px; float: left"></div>
                    <div class="tagmid">{{item.text}}</div>
                    <div style="width: 30px; height: 40px; float: left"></div>
                </div>
                <div style="width: 9px; height: 7px; float: left;position:absolute;right:1px;bottom:-7px">
                    <img
                        src="../../assets/images/huang-jia.png"
                        style="display: block"
                        v-if="item.active"
                    />
                </div>
            </li>
        </ul>
        <div class="pdf"><a href="https://ftpc.wenhua.com.cn/files/guide/wh7/download/%E5%A5%97%E5%88%A9%E4%BA%A4%E6%98%93%E5%B7%A5%E5%85%B7%E6%93%8D%E4%BD%9C%E6%89%8B%E5%86%8C.pdf" target="_blank">下载套利交易工具操作手册</a></div>
      </div>
      <div style="height: 18px"></div>
      <div class="productcenterbodytext" ref="box">
        <div
          style="
            width: 780px;

            border-radius: 2%;
            position: relative;
          "
        >
          <div class="midtext">
            <div v-if="leftnav.filter((el)=>{return el.id=='jj'})[0].active">
              <h4 class="head4" id="productcentertwo">一、简介</h4>
              <p class="pproduct">
                wh7软件提供专业的套利分析工具和下单工具，支持用户自由组合设置套利合约，提供超长套利价差K线图和分析工具；可自动监控价差执行下单操作，设置合约交易优先级降低瘸腿概率、套利分批下单降低冲击成本，还支持一键多账户套利交易、套利风控单等专业下单功能。
              </p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='zypd'})[0].active">
              <h4 class="head4" id="productcentertwo">二、配置套利合约</h4>
              <p class="pproduct">
                软件支持任意合约自由组合套利，如国内跨期、国内跨品种、黄金T+D以及内外盘自由组合套利，提供两腿合约价差套利、价比套利以及蝶式套利多种套利类型，还可以引用汇率、升帖水等自由配置套利公式。
              </p>
              <p class="pproduct">
                如下图，是设置套利配对的方法，以基于压榨利润公式设置大豆提油套利为例。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC1-1.png" /></p>
              <p class="pproduct">
                设置好的套利合约可以在【套利】->自设套利合约报价列表中查看，如下图。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC1-2.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='kxt'})[0].active">
              <h4 class="head4" id="productcenterthree">
                三、套利K线图
              </h4>
              <p class="pproduct">
                软件提供带上下影线的套利价差/价比K线图，由逐笔TICK数据计算合成，可以准确反映套利价差/价比走势，套利k线图与单合约一致，支持加载技术分析指标，做套利像做单合约一样方便。
              </p>
              <p class="pproduct">
                如下图，是大豆提油套利策略的价差K线图，从图表上便能直观的观察压榨利润波动，分析套利机会。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC2-1.jpg" /></p>
              <p class="pproduct">
                当需要做技术分析时，通过鼠标右键中的【叠加/删除技术指标】即可在K线图上增加分析指标或切换副图指标。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC2-2.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='fxgj'})[0].active">
              <h4 class="head4" id="productcenterfour">四、套利分析工具</h4>
              <p class="pproduct">
                软件提供专业的价差分析工具，如下图，在套利合约K线图上点击右键，可查看两腿合约的价差周期性图、二腿价格走势百分比图、二腿相关度、价差分布图以及二腿价格走势图分析。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC3-1.jpg" /></p>
              <p class="pimg"><img src="@/../public/proimg/TLSC3-2.png"  style="width:600px"/></p>
              <p class="pproduct">
                软件还提供价差矩阵，用于跨期套利的升贴水分析。如下图，点击【套利】->价差矩阵，选择市场和品种设置即可。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/TLSC3-3.jpg')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='jcjy'})[0].active">
              <h4 class="head4" id="productcenterfive">五、套利价差交易</h4>
              <p class="pproduct">
                软件提供套利专用下单界面（【套利】->自设套利下单），交易员可对套利合约设置价差判断，添加下单任务到后台运行，由软件实时监控价差变动，符合价差条件时自动下单，轻松实现套利交易。还支持智能分批下单以及撤单辅助算法，自动撤单/追价，有效控制成交滑点。
              </p>
              <h5 class="head5" >1、套利开仓</h5>
              <p class="pproduct">
                如下图，是设置套利开仓任务的操作方法。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/TLSC4-1.jpg')"></BaseBigimg>
              <p class="pproduct">注：可选择下单模式，</p>
              <p class="pproduct">震荡模式：买入下单时在对价差&lt;=设置价差时发出委托；卖出下单时相反。</p>
              <p class="pproduct">突破模式：买入下单时在对价差>=设置价差时发出委托；卖出下单时相反。</p>
              <h5 class="head5" >2、套利平仓</h5>
              <p class="pproduct">
                方法1：在【配对持仓】中选择要平仓的套利持仓，添加平仓下单任务；
              </p>
              <p class="pproduct">
                方法2：在【配对持仓】中选择要平仓的套利持仓，点击右键，选择对手价平仓。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/TLSC4-2.jpg')"></BaseBigimg>
              <h5 class="head5" >3、套利撤单</h5>
              <p class="pproduct">
                未成交的委托可以执行撤单操作。如下图，点击撤单和清理未配对持仓执行相应的撤单操作。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/TLSC4-3.jpg')"></BaseBigimg>
              <p class="pproduct">注：</p>
              <p class="pproduct">1、“撤单”是指立即终止这次的套利交易行为，将未成交的委托撤单，但是在点这个按钮之前的成交合约保留。</p>
              <p class="pproduct">2、点击“撤单”再点击“清理未配对持仓”，是指立即终止这次的套利交易行为，但是在点这个按钮之前已经完成配对的套利对保留，并自动撤掉挂单，并平掉没有配对的持仓。</p>
              <h5 class="head5" >4、套利撤单算法控制成交滑点</h5>
              <p class="pproduct">
                自设套利合约下单时，可启用撤单算法，由软件自动监控挂单时长和价差偏离值，达到条件自动撤单，有效控制成交滑点。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/TLSC4-4.jpg')"></BaseBigimg>
              <p class="pproduct">注：</p>
              <p class="pproduct">1、辅助算法自动撤单后，下单任务不会终止，当价差满足条件会再次委托，直到下单份数全部成交（自动追市价算法除外）；</p>
              <p class="pproduct">2、套利下单任务的撤单算法触发后不会进行清理未配对操作，若产生瘸腿，需手动清理未配对持仓；</p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='tlxd'})[0].active">
              <h4 class="head4" id="productcentersix">六、多账号套利一键下单</h4>
              <p class="pproduct">
                当同时登录多个账号交易时，可以将多个账号设置成“账号组”，对组一键套利下单，如下图，多账号的套利任务、委托可合并显示，像操作单个账号一样简单。
              </p>
              <BaseBigimg :src="require('@/../public/proimg/TLSC5-1.jpg')"></BaseBigimg>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='hxxd'})[0].active">
              <h4 class="head4" id="productcenterseven">七、套利画线下单</h4>
              <p class="pproduct">
                软件提供自设套利画线下单工具，可以选择买卖交易方向，直接在目标价差位置画线，添加下单任务，如下图，当盘中价差满足条件便可自动执行下单。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC6-1.jpg" /></p>
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='fkd'})[0].active">
              <h4 class="head4" id="productcentereleven">
                八、套利风控单
              </h4>
              <p class="pproduct">
                套利风控单可以帮助交易员监控各套利仓单的盈亏情况，并自动按照交易员预设的订单内容执行加仓/减仓风控操作。
              </p>
              <p class="pproduct">
                点击软件右上角【套利】->自设套利下单->设风控单，按下图步骤进行设置套利风控单。
              </p>
              <p class="pimg"><img src="@/../public/proimg/TLSC7-1.jpg" /></p>
              <p class="pproduct">注：自设套利风控单在本机运行，软件关闭或退出交易会失效；</p>
              <br />
            </div>
            <div v-if="leftnav.filter((el)=>{return el.id=='syjq'})[0].active">
              <h4 class="head4" id="productcentereleven">
                九、套利交易工具使用技巧
              </h4>
              <h5 class="head5" >1、套利价差交易如何立即开仓/立即平仓？</h5>
              <p class="pproduct">
               答：套利下单为价差触发形式，如需立即开仓/平仓，可以在添加任务时将价差填写为已满足触发条件的数值：
              </p>
              <p class="pproduct">买入开仓/买入平仓，填写大于等于当前对价差的数值；</p>
              <p class="pproduct">卖出开仓/卖出平仓，填写小于等于当前对价差的数值；</p>
              <p class="pproduct">另，在配对持仓列表点击右键选择对手价平仓，可立即平仓；</p>
              <p class="pproduct">注：价差数值需结合合约波动情况综合考量，如果行情波动太快也无法保证立即触发；</p>
              <h5 class="head5" >2、套利下单时两个套利合约的下单手数可否不一致？如玉米买入2手，豆油卖出1手。</h5>
              <p class="pproduct">答：可以，如下图，在交易参数设置界面->配比，将玉米的配比设置为2，豆油设置为1，下单时就会按照玉米2手、豆油1手发委托。</p>
              <p class="pimg"><img src="@/../public/proimg/TLSC8-2.jpg" /></p>
              <h5 class="head5" >3、套利下单时两腿合约的委托方式可否不一致？如第一腿以对手价委托，第二腿以市价委托？</h5>
              <p class="pproduct">答：可以的，如下图，在交易参数设置界面->价格方式，可对两腿合约分别设置委托方式。</p>
              <p class="pimg"><img src="@/../public/proimg/TLSC8-3.jpg" /></p>
              <br />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      leftnav:[{active:true,text:'简介',id:'jj'},
      {active:false,text:'配置套利合约',id:'zypd'},
      {active:false,text:'套利K线图',id:'kxt'},
      {active:false,text:'套利分析工具',id:'fxgj'},
      {active:false,text:'套利价差交易',id:'jcjy'},
      {active:false,text:'多账号套利一键下单',id:'tlxd'},
      {active:false,text:'套利画线下单',id:'hxxd'},
      {active:false,text:'套利风控单',id:'fkd'},
      {active:false,text:'套利交易工具使用技巧',id:'syjq'},],
      class1: "onclick",
      class2: "noclick",
      class3: "touming",
      class4: "yellow",
      class5: "noclickone",
      class6: "noclickele",
    };
  },
  methods: {
    show(index){
        console.log()
        this.leftnav.forEach((el,idx)=>{
            el.active=false
        })
        this.leftnav[index].active=true
    },
   
  },
  created(){
  }

};
</script>

<style scoped>
.eeee {
  color: blue;
}
.eeee :visited {
  color: blue;
}
.productcenterhtml {
  background: url("../../assets/images/ts-bg_02.jpg") no-repeat top, #eef0ff;
  background-size: 100%;
  min-width: 1400px;
  width: 100%;
}
.productcenterhead {
  position: relative;
  height: 140px;
  width: 1000px;
  margin: 0 auto;
}
.productcenterheadtext {
  position: absolute;
  top: 90px;
}
.productcenterbody {
  width: 1000px;
  margin: 0 auto;
  position: relative;
}
.productcenterbodytag {
  width: 570px;
  height: 518px;
  border-radius: 2%;
  background: url("../../assets/images/ts-2_01.png") no-repeat center;
  background-size: 100% 100%;
  position: absolute;
}
.productcenterbodytext {
  margin-left: 220px;
  width: 780px;
  min-height: 680px;
  border-top-left-radius: 1em;
  background: url("../../assets/images/ts-2_02.jpg") no-repeat top #f7f7f7;
  background-size: 100%;
  overflow-x: hidden;
  filter: drop-shadow(1px 1px 2px #dee0f1);
}
.noclick {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #ebcb91;
  color: #69532b;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.onclick {
  height: 42px;
  line-height: 42px;
  background: #fdfdfd;

  width: 220px;
  letter-spacing: 1px;

  text-align: left;

  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;

  color: #4e2c2b;
}
.touming {
  width: 5px;
  height: 42px;
  float: left;
}
.yellow {
  width: 5px;
  height: 42px;
  background: #915c0e;
  float: left;
  border-top-left-radius: 0.1em;
  border-bottom-left-radius: 0.1em;
}
.head4 {
  color: #1a1c4b;
  font-size: 16px;
  padding-top: 20px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.midtext {
  margin: 0 auto;
  width: 680px;
  padding-bottom: 30px;
}
.pproduct {
  font-size: 15px;
  text-indent: 2em;
  letter-spacing: 1px;
  color: #727983;
  line-height: 25px;
  /* width: 700px; */
  text-align: justify;
}
.pimg {
  padding-top: 10px;
  padding-bottom: 10px;
  min-height: 50px;
  width: 100%;
  text-align: center;
}
.noclick:hover {
  color: #f59726;
}
.pli {
  width: 235px;
  height: 42px;
  margin-left: -5px;
  position: relative;
  z-index: 88;
}
.head5 {
  color: #1a1c4b;
  font-size: 15px;
  padding-top: 10px;
  padding-bottom: 10px;
  font-weight: bold;
  letter-spacing: 1px;
}
.ppro {
  font-size: 15px;
  letter-spacing: 1px;

  color: #727983;
  line-height: 25px;
  width: 670px;
  padding-left: 2em;
}
.pro {
  font-size: 15px;

  letter-spacing: 1px;
  color: #727983;
  line-height: 25px;
  width: 670px;
  text-indent: 2em;
}
.noclickone {
  height: 41px;
  line-height: 41px;

  letter-spacing: 1px;
  width: 220px;

  border-top: 1px solid #ebcb91;
  color: #69532b;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.pli:last-child .noclickone{
 border-bottom: 1px solid #ebcb91;
}
.noclickele {
  height: 40px;
  line-height: 40px;

  letter-spacing: 1px;
  width: 220px;
  border-bottom: 1px solid #ebcb91;
  border-top: 1px solid #ebcb91;
  color: #69532b;
  text-align: left;
  float: left;
  font-size: 14px;
  font-weight: normal;
  cursor: pointer;
}
.noclickone:hover {
  color: #f59726;
}
.noclickele:hover {
  color: #f59726;
}
.tagmid {
  width: 150px;
  height: 42px;
  float: left;
  font-weight: bold;
}
.pdf {
    margin-top:60px ;
    height: 90px;
    width: 220px;
    text-align: center;
    line-height: 90px;
}
.pdf a{
  color: #5050cc;
  text-decoration: none;
  font-size: 14px;
}
.pdf a:hover{
  text-decoration:underline;
}
.pdf a:visited{
  color: #5050cc;
}
</style>